import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TOptions } from 'i18next';
import { MessagePaths } from '../utils/messageTypeUtils';
import { capitalizeFirstLetter } from '@shared/utils';

type Format = 'capitalize' | 'uppercase' | 'lowercase';
type FormatFn = (str: string) => string;

const formatMap: Record<Format, FormatFn> = {
  capitalize: capitalizeFirstLetter,
  uppercase: (str) => str.toUpperCase(),
  lowercase: (str) => str.toLowerCase(),
};

export const useMessagesTranslation = <MessagesT extends Record<string, any>>() => {
  const translation = useTranslation();
  const { t } = translation;

  const appT = useCallback(
    (key: MessagePaths<MessagesT>, options?: TOptions, format?: Format) => {
      const [keyNs, ...rest] = key.split('.');

      const text = t(rest.join('.'), {
        ns: keyNs,
        ...options,
      });

      return format ? formatMap[format](text) : text;
    },
    [t]
  );

  return {
    ...translation,
    t: appT,
  };
};
